import { Injectable } from '@angular/core';
import { EventBusService } from '@web/common';

@Injectable()
export class AdminDictionaryEventBusService extends EventBusService {}
